define.alias("shared/components/shared/social-identity/placeholder-item", "media/components/shared/social-identity/placeholder-item");